import clsx from 'clsx';

import styles from './DotIndicator.module.css';
/**
 * A dot used to indicate, for example, when we have at least 1 open CR or a draft CR
 */
export function DotIndicator(props: {
    disabled?: boolean;
    kind?: 'upgrade' | 'success' | 'warning' | 'danger' | 'primary';
    className?: string;
}) {
    const { disabled, kind = 'danger', className } = props;
    return (
        <div
            className={clsx(
                'rounded-full',
                styles.dot,
                styles[kind],
                disabled && styles.disabled,
                className
            )}
        />
    );
}
